// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"b69478c9","990":"19e22b6a"}[chunkId] + ".chunk.css";
};